import React from 'react';
const IconUpload = ({color}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 1.333c-.736 0-1.333.597-1.333 1.334v10.666c0 .737.597 1.334 1.333 1.334h8c.736 0 1.333-.597 1.333-1.334v-8l-4-4H4m4.667 1.334V6H12v7.333H4V2.667h4.667zm0 4H7.333v2h-2V10h2v2h1.334v-2h2V8.667h-2v-2z" fill={color} fill-rule="evenodd"/>
    </svg>
  )
}
export default IconUpload;
